import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "midTitle mb-2" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "my-4 d-flex justify-content-around" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "text-end mt-4" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_date = _resolveComponent("op-date")!
  const _component_op_time = _resolveComponent("op-time")!
  const _component_new_comment_form = _resolveComponent("new-comment-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Nuova azione",
        text: "Nuova azione"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Data",
          text: "Data"
        })
      ]),
      _createVNode(_component_op_date, {
        class: "form-control",
        modelValue: _ctx.vm.startDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.startDate) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ora",
          text: "Ora"
        })
      ]),
      _createVNode(_component_op_time, {
        class: "form-control",
        modelValue: _ctx.startTime,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startTime) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-hollow", { 'btn-primary': _ctx.vm.type == 'Whatsapp' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.type = 'Whatsapp'))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Whatsapp",
          text: "Whatsapp"
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-hollow", { 'btn-primary': _ctx.vm.type == 'Chiamata' }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vm.type = 'Chiamata'))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Chiamata",
          text: "Chiamata"
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-hollow", { 'btn-primary': _ctx.vm.type == 'Check' }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.vm.type = 'Check'))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Check",
          text: "Check"
        })
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Tipo azione",
          text: "Tipo azione"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vm.type) = $event))
      }, null, 512), [
        [_vModelText, _ctx.vm.type]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Note e allegati",
          text: "Note e allegati"
        })
      ]),
      _createVNode(_component_new_comment_form, {
        modelValue: _ctx.addCommentVm,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addCommentVm) = $event))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("span", null, null, -1)
        ])),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
        disabled: !_ctx.canSave
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Salva",
          text: "Salva"
        })
      ], 8, _hoisted_9),
      _createElementVNode("button", {
        class: "btn btn-danger ms-2",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Chiudi",
          text: "Chiudi"
        })
      ])
    ])
  ]))
}